import { render, staticRenderFns } from "./ShortCutWebpart.vue?vue&type=template&id=7ef6b55a"
import script from "./ShortCutWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ShortCutWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports